import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useParams, useNavigate } from 'react-router-dom';
import { PlusCircle, Image, Send, ArrowLeft, Trash2 } from 'react-feather';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import CameraCapture from '../../pages/CameraCapture';
import api from '../Api';

function WorkOrderProgress({ onCapture }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [previewImg, setPreviewImg] = useState(null);
  const [show, setShow] = useState(false);
  const [showAssignment, setShowAssignment] = useState(false);
  const [assignmentType, setAssignmentType] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [manualMembers, setManualMembers] = useState([]);
  const [showDone, setShowDone] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const [showCameraBefore, setShowCameraBefore] = useState(false);
  const [showCameraAfter, setShowCameraAfter] = useState(false);
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);
  const STORAGE_BASE_URL = 'https://apiworkorder.perumdamtkr.com/storage/';

  const [formData, setFormData] = useState({
    photo_before: null,
  });

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await api.get(`/work-orders/${id}/details`);
        if (res.data.success) {
          setDetail(res.data);
        } else {
          toast.error('Gagal memuat detail tiket');
        }
      } catch (err) {
        console.error('Error ambil detail tiket:', err);
        toast.error('Terjadi kesalahan saat memuat data!');
      } finally {
        setLoading(false);
      }
    };
    fetchDetail();
  }, [id]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!detail) {
    return <div className="alert alert-danger text-center mt-4">Data tidak ditemukan.</div>;
  }

  const workGroups = [
    {
      id: '1',
      name: 'Group Cimahi',
      region: 'Region-01',
      members: [
        { id: 'u1', name: 'Andi', role: 'Teknisi' },
        { id: 'u2', name: 'Budi', role: 'Teknisi' },
        { id: 'u3', name: 'Citra', role: 'Koordinator' },
      ],
    },
    {
      id: '2',
      name: 'Group Bandung',
      region: 'Region-02',
      members: [
        { id: 'u4', name: 'Dedi', role: 'Teknisi' },
        { id: 'u5', name: 'Eka', role: 'Teknisi' },
        { id: 'u6', name: 'Fajar', role: 'Koordinator' },
      ],
    },
    {
      id: '3',
      name: 'Group Jakarta',
      region: 'Region-03',
      members: [
        { id: 'u7', name: 'Gilang', role: 'Teknisi' },
        { id: 'u8', name: 'Hana', role: 'Teknisi' },
        { id: 'u9', name: 'Indra', role: 'Koordinator' },
      ],
    },
  ];

  const allUsers = [
    { id: 'u10', name: 'Joko', role: 'Teknisi', region: 'Region-01' },
    { id: 'u11', name: 'Karin', role: 'Koordinator', region: 'Region-01' },
    { id: 'u12', name: 'Lutfi', role: 'Teknisi', region: 'Region-02' },
    { id: 'u13', name: 'Maya', role: 'Teknisi', region: 'Region-02' },
    { id: 'u14', name: 'Nando', role: 'Teknisi', region: 'Region-03' },
    { id: 'u15', name: 'Oki', role: 'Koordinator', region: 'Region-03' },
    { id: 'u16', name: 'Putri', role: 'Teknisi', region: 'Region-04' },
    { id: 'u17', name: 'Rudi', role: 'Teknisi', region: 'Region-04' },
  ];

  // Ambil group yang dipilih
  const groupDetail = workGroups.find((g) => g.id === selectedGroup);

  // Toggle member
  const handleToggleMember = (id) => {
    setSelectedMembers((prev) => (prev.includes(id) ? prev.filter((m) => m !== id) : [...prev, id]));
  };

  const userOptions = allUsers.map((u) => ({
    value: u.id,
    label: `${u.name} - ${u.role} (${u.region})`,
  }));

  const handleAddManual = (option) => {
    const user = allUsers.find((u) => u.id === option.value);
    if (user && !manualMembers.find((m) => m.id === user.id)) {
      setManualMembers((prev) => [...prev, user]);
    }
  };

  const handleRemoveManual = (id) => {
    setManualMembers((prev) => prev.filter((m) => m.id !== id));
  };

  // === HANDLE PREVIEW ===
  const handlePreview = (img) => {
    setPreviewImg(img);
    setShow(true); // buka modal
  };

  const handleClose = () => {
    setShow(false); // tutup modal
    setPreviewImg(null);
  };

  if (!detail) {
    return (
      <div className="container mt-4">
        <h4>Data tidak ditemukan</h4>
        <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>
          Kembali
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="container mt-4">
        <div className="card shadow-sm">
          {/* Header utama */}
          <div className="card-header" style={{ backgroundColor: '#1a237e' }}>
            <h5 className="mb-0 text-white">Detail Tiket {detail.external_ref}</h5>
          </div>

          <div className="card-body">
            <div className="d-flex justify-content-end gap-2 px-3 py-2" style={{ backgroundColor: '#f5f6fa' }}>
              {/* Modal Done */}
              <Modal show={showDone} onHide={() => setShowDone(false)} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Konfirmasi Selesai</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Apakah Anda yakin tiket ini sudah <b>selesai</b>?
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowDone(false)}>
                    Batal
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      console.log('Tiket selesai');
                      setShowDone(false);
                    }}
                  >
                    Ya, Selesai
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* Modal Reject */}
              <Modal show={showReject} onHide={() => setShowReject(false)} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Konfirmasi Tolak</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Apakah Anda yakin ingin <b>menolak</b> tiket ini?
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowReject(false)}>
                    Batal
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => {
                      console.log('Tiket ditolak');
                      setShowReject(false);
                    }}
                  >
                    Ya, Tolak
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>

            {/* Tabel detail */}
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>Nama Pelanggan</th>
                    <td style={{ width: '30%' }}>{detail.nama}</td>
                    <th style={{ width: '20%' }}>Telepon</th>
                    <td style={{ width: '30%' }}>{detail.no_hp}</td>
                  </tr>
                  <tr>
                    <th>Alamat</th>
                    <td>{detail.alamat}</td>
                    <th>Status Pelanggan</th>
                    <td>{detail.customer ? 'Pelanggan' : 'Non Pelanggan'}</td>
                  </tr>
                  <tr>
                    <th>Media</th>
                    <td>{detail.nama_channel}</td>
                    <th>Category</th>
                    <td>{detail.category}</td>
                  </tr>
                  <tr>
                    <th>Wilayah</th>
                    <td>{detail.nama_wilayah}</td>
                    <th>Provinsi</th>
                    <td>{detail.nama_propinsi}</td>
                  </tr>
                  <tr>
                    <th>Kabupaten</th>
                    <td>{detail.nama_kabupaten}</td>
                    <th>Kecamatan</th>
                    <td>{detail.nama_kecamatan}</td>
                  </tr>
                  <tr>
                    <th>Kelurahan</th>
                    <td>{detail.nama_kelurahan}</td>
                    <th>Priority</th>
                    <td>
                      <span
                        className={`badge ${
                          detail.priority === 'critical'
                            ? 'bg-danger'
                            : detail.priority === 'medium'
                              ? 'bg-warning text-dark'
                              : 'bg-success'
                        }`}
                      >
                        {detail.priority}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>Keluhan</th>
                    <td>{detail.description}</td>
                    <th>Bukti Foto</th>
                    <td>
                      {detail.complaint_pic ? (
                        <button
                          className="btn btn-sm btn-primary d-flex align-items-center"
                          onClick={() => handlePreview(`${STORAGE_BASE_URL}${detail.complaint_pic}`)}
                        >
                          <Image size={16} className="me-1" />
                          Lihat Gambar
                        </button>
                      ) : (
                        <span className="text-muted">Tidak ada bukti foto</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Petugas</th>
                    <td>{detail.details?.[0]?.username || '-'}</td>
                    <th>Kasie</th>
                    <td>{detail.details?.[0]?.kasie || '-'}</td>
                  </tr>
                  {[4].includes(JSON.parse(localStorage.getItem('user'))?.role_id) && (
                    <tr>
                      <th>Foto Sebelum Perbaikan</th>
                      <td>
                        <button onClick={() => setShowCameraBefore(true)} className="btn btn-danger">
                          📸 Ambil Foto
                        </button>

                        {/* Modal untuk foto SEBELUM */}
                        <Modal show={showCameraBefore} onHide={() => setShowCameraBefore(false)} centered>
                          <Modal.Body>
                            <CameraCapture
                              onCapture={(dataUrl) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  photo_before: dataUrl,
                                }));
                                setShowCameraBefore(false);
                              }}
                              onClose={() => setShowCameraBefore(false)}
                            />
                          </Modal.Body>
                        </Modal>
                      </td>

                      <th>Foto Sesudah Perbaikan</th>
                      <td>
                        <button onClick={() => setShowCameraAfter(true)} className="btn btn-danger">
                          📷 Ambil Foto
                        </button>

                        {/* Modal untuk foto SESUDAH */}
                        <Modal show={showCameraAfter} onHide={() => setShowCameraAfter(false)} centered>
                          <Modal.Body>
                            <CameraCapture
                              onCapture={(dataUrl) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  photo_after: dataUrl,
                                }));
                                setShowCameraAfter(false);
                              }}
                              onClose={() => setShowCameraAfter(false)}
                            />
                          </Modal.Body>
                        </Modal>
                      </td>
                    </tr>
                  )}
                  {[4].includes(JSON.parse(localStorage.getItem('user'))?.role_id) && (
                    <tr>
                      <th>Aksi</th>
                      <td colSpan={3}>
                        <button
                          className="btn text-white d-flex align-items-center"
                          style={{ backgroundColor: 'rgb(29, 145, 37)' }}
                          onClick={() => {
                            setShowAssignment(true);
                            setAssignmentType('manual');
                          }}
                        >
                          <PlusCircle size={18} className="me-2" />
                          Join Member
                        </button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Section Penugasan */}
            {showAssignment && (
              <div className="card">
                <div className="py-3 px-3 text-white" style={{ backgroundColor: '#3949ab' }}>
                  <h6 className="mb-0 text-white">Penugasan Tiket</h6>
                </div>
                <div className="card-body">
                  {/* Jika pilih group */}
                  {assignmentType === 'group' && (
                    <>
                      {/* Dropdown pilih group */}
                      <div className="mb-3">
                        <label className="form-label">Pilih Group</label>
                        <select
                          className="form-select"
                          value={selectedGroup}
                          onChange={(e) => {
                            setSelectedGroup(e.target.value);
                            setSelectedMembers([]);
                          }}
                        >
                          <option value="">-- Pilih Group --</option>
                          {workGroups.map((g) => (
                            <option key={g.id} value={g.id}>
                              {g.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Jika sudah pilih group */}
                      {groupDetail && (
                        <div className="table-responsive">
                          <table className="table table-bordered align-middle">
                            <thead>
                              <tr>
                                <th>Group</th>
                                <th>Wilayah</th>
                                <th>Anggota</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{groupDetail.name}</td>
                                <td>{groupDetail.region}</td>
                                <td>
                                  <ul className="list-unstyled mb-0">
                                    {groupDetail.members.map((m) => (
                                      <li key={m.id}>
                                        <label className="form-check-label">
                                          <input
                                            type="checkbox"
                                            className="form-check-input me-2"
                                            checked={selectedMembers.includes(m.id)}
                                            onChange={() => handleToggleMember(m.id)}
                                          />
                                          {m.name} - <em>{m.role}</em>
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <button className="btn btn-kirim d-flex align-items-center" type="submit">
                            <Send size={16} className="me-2" />
                            Kirim Tiket
                          </button>
                        </div>
                      )}
                    </>
                  )}

                  {/* Jika pilih manual */}
                  {assignmentType === 'manual' && (
                    <div>
                      <div className="mb-3">
                        <label className="form-label">Cari & Tambah Petugas</label>
                        <Select
                          options={userOptions}
                          onChange={handleAddManual}
                          placeholder="Cari nama petugas..."
                          isSearchable
                        />
                      </div>

                      {/* Tabel petugas yang dipilih */}
                      {manualMembers.length > 0 && (
                        <div className="table-responsive">
                          <table className="table table-bordered align-middle">
                            <thead>
                              <tr>
                                <th>Nama</th>
                                <th>Role</th>
                                <th className="text-center">Aksi</th>
                              </tr>
                            </thead>
                            <tbody>
                              {manualMembers.map((m) => (
                                <tr key={m.id}>
                                  <td>{m.name}</td>
                                  <td>{m.role}</td>
                                  <td className="text-center">
                                    <button className="btn btn-sm btn-danger" onClick={() => handleRemoveManual(m.id)}>
                                      <Trash2 size={16} />
                                      Hapus
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <button className="btn btn-kirim d-flex align-items-center" type="submit">
                            <Send size={16} className="me-2" />
                            Kirim Tiket
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Action buttons */}
            {/* Footer Aksi */}
            <div className="d-flex justify-content-between mt-3">
              {/* Kiri */}
              <div>
                <button className="btn btn-secondary d-flex align-items-center" onClick={() => navigate(-1)}>
                  <ArrowLeft size={16} className="me-1" />
                  Kembali
                </button>
              </div>

              {/* Kanan */}
              <div>
                {/* <button className="btn btn-success d-flex align-items-center">
                  <Download size={16} className="me-1" />
                  Ambil Tiket
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Preview */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Preview Foto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {previewImg ? (
            <img src={previewImg} alt="Preview" className="img-fluid rounded shadow" />
          ) : (
            <p className="text-muted">Tidak ada gambar</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default WorkOrderProgress;
